import {createRouter, createWebHistory} from "vue-router"
import {nextTick, ref} from "vue"
import "@/router/paths"
import RouteDesigner from "@/router/RouteDesigner"
import Pipeline from "@/middleware/Pipeline"

export const isNavigating = ref(false)
export const isNavigatingError = ref(false)
export const navigatingErrorMessage = ref('')

const router = createRouter({
  history: createWebHistory(),
  routes: RouteDesigner.compile(),
  scrollBehavior(to, from, savedPosition) {

    if (to.hash && document.querySelector(to.hash)) {
      return {
        el: to.hash,
        top: 130,
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    return {top: 0}
  }
})


const pipeline = new Pipeline()
router.beforeEach(async (to, from, next) => {
  await nextTick()
  isNavigating.value = true
  isNavigatingError.value = false
  navigatingErrorMessage.value = ''
  // Pass Vue Router's next to the middleware pipeline so it can continue or redirect
  await pipeline.handle(to, from, next)
})
router.afterEach(async () => {
  await nextTick()
  isNavigating.value = false
})

// Handle navigation errors
router.onError((error) => {
  isNavigatingError.value = true
  navigatingErrorMessage.value = error.message
  isNavigating.value = false
})

export default router
